module.exports = __webpack_public_path__ + "d531d510.svg";